/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }

  // 获取这个账号下的组长
  async getLeaderList() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/leaders`
    );
    return response;
  }

  // 获取这个账号下的审核员
  async getCheckerList() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/checkers`
    );
    return response;
  }

  // 批量分配会话
  async bulkAssign(data) {
    const response = axios.post(
      `/api/v1/accounts/${this.accountIdFromRoute}/bulk_assignments`,
      data
    );
    return response;
  }
}

export default new AccountAPI();
